const config = {
  baseUrl: process.env.REACT_APP_BASE_URL || "http://127.0.0.1:8000",
  environment: process.env.REACT_APP_ENV || "development",
  faqListUrl: process.env.REACT_APP_RESOURCE_URL || "",
  apiAccessKey: process.env.REACT_APP_API_KEY || "",
  version: process.env.REACT_APP_VERSION || "v1.0.0",
  msal: {
    azureClientId: process.env.REACT_APP_AZURE_CLIENT_ID || "",
    azureTenantId: process.env.REACT_APP_AZURE_TENANT_ID || "",
    knownAuthorities: process.env.REACT_APP_KNOWN_AUTHORITIES || "",
    redirectUrl: process.env.REACT_APP_REDIRECT_URL || 'http://localhost:3000',
  },
  errorResponseMessage:
    "I apologize for the inconvenience. I'm unable to access the information you requested at this time.",
};

export { config };
